import React, { useState, useEffect } from 'react';
import propertiesData from '../data/properties.json';
import { getTheme } from '../data/themes';
import BoardCenter from './BoardCenter';
import { TokenIcon } from './TokenIcon';
import { sounds } from '../utils/sounds';
import './Board.css';

export { TokenIcon };


// Vektörel İllüstrasyonlar (Sade, Yüksek Kaliteli SVG İkonları)
const SpaceIcon = ({ type, name }) => {
  const isIskele = type === 'railroad' && (name?.includes('İskele') || name?.includes('Vapur'));
  const isMetro = type === 'railroad' && !isIskele;
  
  const isIzsu = name && (name.toUpperCase().includes('İZSU') || name.toUpperCase().includes('IZSU'));
  const isGediz = name && name.toUpperCase().includes('GEDİZ');

  const svgStyle = {
    width: 'var(--space-icon-size, 22px)',
    height: 'var(--space-icon-size, 22px)',
    maxWidth: '85%',
    maxHeight: '42%',
    flexShrink: 0
  };

  if (isIskele) {
    // Vapur / İskele SVG
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 2px 5px rgba(0,0,0,0.5))' }}>
        <path d="M4 25 C4 25, 11 29, 18 29 C25 29, 32 25, 32 25 L30 18 L6 18 Z" fill="#38bdf8" stroke="#ffffff" strokeWidth="1.6" />
        <rect x="11" y="11" width="14" height="7" rx="1.5" fill="#ffffff" stroke="#0284c7" strokeWidth="1.4" />
        <rect x="16" y="6" width="4" height="5" fill="#ef4444" rx="0.5" />
        <circle cx="14" cy="14.5" r="1.4" fill="#0284c7" />
        <circle cx="18" cy="14.5" r="1.4" fill="#0284c7" />
        <circle cx="22" cy="14.5" r="1.4" fill="#0284c7" />
        <path d="M2 30 C7 32, 11 30, 18 30 C25 30, 29 32, 34 30" stroke="#7dd3fc" strokeWidth="1.8" strokeLinecap="round" fill="none" />
      </svg>
    );
  }

  if (isMetro) {
    // Metro / Tren SVG
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 2px 5px rgba(0,0,0,0.5))' }}>
        <rect x="7" y="6" width="22" height="20" rx="4" fill="#1e1b4b" stroke="#a78bfa" strokeWidth="1.6" />
        <rect x="10" y="9" width="16" height="9" rx="1.5" fill="#38bdf8" stroke="#0f172a" strokeWidth="1" />
        <circle cx="12" cy="22" r="2" fill="#fbbf24" stroke="#0f172a" strokeWidth="0.8" />
        <circle cx="24" cy="22" r="2" fill="#fbbf24" stroke="#0f172a" strokeWidth="0.8" />
        <line x1="16" y1="20" x2="20" y2="20" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 26 L7 31 M24 26 L29 31" stroke="#cbd5e1" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    );
  }

  if (isIzsu) {
    // Su Damlası SVG (İZSU - Oceanic Water Drop)
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 2px 6px rgba(2, 132, 199, 0.6))' }}>
        <path d="M18 3 C18 3, 7 15, 7 23 C7 29 11.9 33 18 33 C24.1 33 29 29 29 23 C29 15, 18 3, 18 3 Z" fill="url(#izsuGrad)" stroke="#ffffff" strokeWidth="1.8" />
        <path d="M13 20 C13 20, 14 26, 21 26" stroke="#7dd3fc" strokeWidth="2" strokeLinecap="round" fill="none" />
        <circle cx="22" cy="16" r="1.8" fill="#ffffff" opacity="0.8" />
        <defs>
          <linearGradient id="izsuGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="50%" stopColor="#0284c7" />
            <stop offset="100%" stopColor="#0369a1" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (isGediz || type === 'utility') {
    // Elektrik Şimşek SVG (Gediz Elektrik - Golden Volt)
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 2px 6px rgba(234, 179, 8, 0.6))' }}>
        <polygon points="20,3 9,19 17,19 13,33 27,15 19,15" fill="url(#gedizGrad)" stroke="#0f172a" strokeWidth="1.6" strokeLinejoin="round" />
        <defs>
          <linearGradient id="gedizGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fef08a" />
            <stop offset="50%" stopColor="#eab308" />
            <stop offset="100%" stopColor="#ca8a04" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (type === 'chance') {
    // İzmir Halleri / Şans Kartı SVG
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 2px 6px rgba(234, 88, 12, 0.6))' }}>
        <rect x="7" y="4" width="22" height="28" rx="4" fill="url(#chanceGrad)" stroke="#fbbf24" strokeWidth="1.6" />
        <text x="18" y="24" fontSize="19" fontWeight="900" textAnchor="middle" fill="#ffffff" fontFamily="Outfit, sans-serif">?</text>
        <defs>
          <linearGradient id="chanceGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f97316" />
            <stop offset="100%" stopColor="#c2410c" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (type === 'community_chest') {
    // Hemşehri Sandığı - 3D Hazine Sandığı SVG
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 3px 6px rgba(0, 0, 0, 0.6))' }}>
        <rect x="4" y="14" width="28" height="17" rx="2" fill="url(#chestBodyGrad)" stroke="#fbbf24" strokeWidth="1.6" />
        <path d="M3 14 C3 8, 33 8, 33 14 Z" fill="url(#chestLidGrad)" stroke="#fbbf24" strokeWidth="1.6" />
        <line x1="4" y1="14" x2="32" y2="14" stroke="#fef08a" strokeWidth="1.4" />
        <rect x="9" y="14" width="3" height="17" fill="#fbbf24" />
        <rect x="24" y="14" width="3" height="17" fill="#fbbf24" />
        <rect x="15.5" y="16" width="5" height="7" rx="1.5" fill="#fef08a" stroke="#78350f" strokeWidth="1" />
        <circle cx="18" cy="19.5" r="1.2" fill="#78350f" />
        <defs>
          <linearGradient id="chestBodyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#a16207" />
            <stop offset="100%" stopColor="#451a03" />
          </linearGradient>
          <linearGradient id="chestLidGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ca8a04" />
            <stop offset="100%" stopColor="#78350f" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (type === 'jail' || type === 'go_to_jail') {
    // Karakol / Sürgün SVG
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 3px 6px rgba(0,0,0,0.6))' }}>
        <rect x="4" y="4" width="28" height="28" rx="4" fill="#0f172a" stroke={type === 'go_to_jail' ? '#f87171' : '#cbd5e1'} strokeWidth="1.8" />
        <line x1="11" y1="4" x2="11" y2="32" stroke="#e2e8f0" strokeWidth="2.2" />
        <line x1="18" y1="4" x2="18" y2="32" stroke="#e2e8f0" strokeWidth="2.2" />
        <line x1="25" y1="4" x2="25" y2="32" stroke="#e2e8f0" strokeWidth="2.2" />
      </svg>
    );
  }

  if (type === 'go') {
    // Saat Kulesi / Başlangıç SVG
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 3px 6px rgba(234, 179, 8, 0.6))' }}>
        <rect x="13" y="10" width="10" height="20" fill="#fef08a" stroke="#78350f" strokeWidth="1.2" />
        <polygon points="18,1 11,10 25,10" fill="#d97706" />
        <circle cx="18" cy="15" r="3" fill="#ffffff" stroke="#78350f" strokeWidth="1.2" />
        <rect x="11" y="30" width="14" height="4" fill="#b45309" rx="1" />
      </svg>
    );
  }

  if (type === 'parking') {
    // Kordon Çimleri SVG
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 3px 6px rgba(22, 101, 52, 0.6))' }}>
        <circle cx="18" cy="18" r="16" fill="url(#parkGrad)" stroke="#ffffff" strokeWidth="1.6" />
        <path d="M11 27 C11 27, 13 13, 18 9 C18 9, 21 17, 25 27 Z" fill="#86efac" stroke="#15803d" strokeWidth="1" />
        <path d="M18 27 C18 27, 16 15, 21 11" stroke="#ffffff" strokeWidth="1.4" fill="none" strokeLinecap="round" />
        <defs>
          <linearGradient id="parkGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#22c55e" />
            <stop offset="100%" stopColor="#15803d" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (type === 'tax') {
    // Vergi Kesintisi / Alaçatı Hesabı SVG
    return (
      <svg className="space-icon-svg" viewBox="0 0 36 36" style={{ ...svgStyle, filter: 'drop-shadow(0 3px 6px rgba(225, 29, 72, 0.6))' }}>
        <circle cx="18" cy="18" r="15" fill="url(#taxGrad)" stroke="#ffffff" strokeWidth="1.6" />
        <text x="18" y="24" fontSize="19" fontWeight="900" textAnchor="middle" fill="#ffffff" fontFamily="Outfit, sans-serif">₺</text>
        <defs>
          <linearGradient id="taxGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f43f5e" />
            <stop offset="100%" stopColor="#be123c" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  return null;
};

const displayNames = {
  "Konak Meydanı": "Saat Kulesi",
  "Kodes / Ziyaretçi": "Çiğli Sapağı",
  "Kordon Molası": "Kordon Çimleri",
  "Kodese Git": "Çiğli'ye Sürgün!"
};

const Board = ({ 
  gameData, 
  room, 
  isRolling, 
  lastDice, 
  myPlayerId, 
  isMyTurn, 
  sendCommand, 
  onSelectProperty,
  selectedPropertyId,
  setSelectedPropertyId,
  displayedCard,
  cardRevealTimerActive,
  autoRoll,
  autoBuy,
  showOthersCards,
  navigateDeed,
  onOpenPlayers,
  onOpenChat,
  unreadChatCount,
  latestLog,
  logVisible,
  players: propPlayers,
  activeHonks: propActiveHonks,
  activePlayer: propActivePlayer,
  me: propMe
}) => {
  const activePlayer = propActivePlayer || gameData?.players?.find(p => p.playerId === gameData?.activePlayerId);
  const me = propMe || gameData?.players?.find(p => p.playerId === myPlayerId);
  const currentAuctionBidderId = gameData?.auction?.activeBidders?.[gameData?.auction?.currentBidderIndex];
  const isMyBidTurn = gameData?.phase === 'AUCTION' && currentAuctionBidderId === myPlayerId;
  const isMyDebt = gameData?.phase === 'DEBT_RESOLUTION' && gameData?.debt?.debtorId === myPlayerId;

  const [auctionBid, setAuctionBid] = useState(0);
  const [internalActiveHonks, setInternalActiveHonks] = useState({});
  const activeHonks = propActiveHonks || internalActiveHonks;

  useEffect(() => {
    if (gameData?.auction?.currentBid) {
      setAuctionBid(gameData.auction.currentBid + 10);
    }
  }, [gameData?.auction?.currentBid]);

  const cityId = gameData?.settings?.city || room?.settings?.city || 'izmir';
  const activeTheme = getTheme(cityId);
  const boardTiles = gameData?.board || activeTheme.properties || propertiesData;
  const properties = gameData?.properties || {};
  const players = propPlayers || gameData?.players || [];

  const getPlayersOnSpace = (spaceId) => {
    return players.filter(p => p.position === spaceId && !p.bankrupt);
  };

  const getGridPosition = (id) => {
    if (id >= 0 && id <= 10) return { row: 11, col: 11 - id };
    if (id >= 11 && id <= 20) return { row: 21 - id, col: 1 };
    if (id >= 21 && id <= 30) return { row: 1, col: id - 19 };
    if (id >= 31 && id <= 39) return { row: id - 29, col: 11 };
    return { row: 1, col: 1 };
  };

  const getDisplayName = (name) => {
    if (name.startsWith('Mavişehir')) {
      const parts = name.split(' ');
      return parts[0];
    }
    return displayNames[name] || name;
  };

  const getSpaceClass = (space) => {
    const classes = ['board-space'];
    if (space.type === 'go' || space.type === 'jail' || space.type === 'parking' || space.type === 'go_to_jail') {
      classes.push('corner-space');
      classes.push(`space-${space.type}`);
    } else if (space.type === 'railroad') {
      classes.push('railroad-space');
      if (space.name && (space.name.includes('İskele') || space.name.includes('Vapur'))) {
        classes.push('space-iskele');
      } else {
        classes.push('space-metro');
      }
    } else if (space.type === 'utility') {
      classes.push('utility-space');
      if (space.name && space.name.includes('İzsu')) classes.push('space-izsu');
      if (space.name && space.name.includes('Gediz')) classes.push('space-gediz');
    } else if (space.type === 'chance') {
      classes.push('chance-space');
    } else if (space.type === 'community_chest') {
      classes.push('chest-space');
    } else if (space.type === 'tax') {
      classes.push('tax-space');
    } else {
      classes.push('regular-space');
      if (space.color) classes.push(`color-${space.color}`);
    }
    
    if (space.id >= 0 && space.id <= 10) classes.push('side-bottom');
    else if (space.id > 10 && space.id <= 20) classes.push('side-left');
    else if (space.id > 20 && space.id <= 30) classes.push('side-top');
    else if (space.id > 30 && space.id <= 39) classes.push('side-right');
    
    return classes.join(' ');
  };

  // Position tokens INSIDE the space tile bounds so overflow:hidden does not clip them
  const getTokenPositionStyle = (index, total, spaceId) => {
    const isBottom = spaceId >= 0 && spaceId <= 10;
    const isLeft = spaceId > 10 && spaceId <= 20;
    const isTop = spaceId > 20 && spaceId <= 30;
    const isRight = spaceId > 30 && spaceId <= 39;

    const offsetPercent = total === 1 ? 50 : (20 + index * (60 / Math.max(1, total - 1)));

    if (isBottom) {
      return { top: '8px', left: `${offsetPercent}%`, transform: 'translateX(-50%)' };
    }
    if (isLeft) {
      return { top: `${offsetPercent}%`, right: '8px', transform: 'translateY(-50%)' };
    }
    if (isTop) {
      return { bottom: '8px', left: `${offsetPercent}%`, transform: 'translateX(-50%)' };
    }
    if (isRight) {
      return { top: `${offsetPercent}%`, left: '8px', transform: 'translateY(-50%)' };
    }
    return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
  };

  return (
    <div className="board-wood-frame shadow-premium">
      <div className="monopoly-board">
        {/* Dynamic Center Stage */}
        <div className="board-center">
          <BoardCenter
            gameData={gameData}
            room={room}
            isRolling={isRolling}
            lastDice={lastDice}
            myPlayerId={myPlayerId}
            isMyTurn={isMyTurn}
            sendCommand={sendCommand}
            activePlayer={activePlayer}
            me={me}
            isMyBidTurn={isMyBidTurn}
            isMyDebt={isMyDebt}
            auctionBid={auctionBid}
            setAuctionBid={setAuctionBid}
            selectedPropertyId={selectedPropertyId}
            setSelectedPropertyId={setSelectedPropertyId}
            displayedCard={displayedCard}
            cardRevealTimerActive={cardRevealTimerActive}
            autoRoll={autoRoll}
            autoBuy={autoBuy}
            showOthersCards={showOthersCards}
            navigateDeed={navigateDeed}
            onOpenPlayers={onOpenPlayers}
            onOpenChat={onOpenChat}
            unreadChatCount={unreadChatCount}
            latestLog={latestLog}
            logVisible={logVisible}
          />
        </div>
        
        {/* Board Spaces */}
        {boardTiles.map((space) => {
          const pos = getGridPosition(space.id);
          const playersHere = getPlayersOnSpace(space.id);
          const propState = properties?.[space.id];
          
          return (
            <div 
              key={space.id} 
              className={`${getSpaceClass(space)} ${propState?.mortgaged ? 'mortgaged-space' : ''}`}
              style={{ 
                gridRow: pos.row, 
                gridColumn: pos.col, 
                cursor: 'pointer'
              }}
              onClick={() => onSelectProperty && onSelectProperty(space.id)}
            >
              {space.color ? (
                <div className="color-bar">
                  {/* Houses & Hotels 3D Representation on Tile */}
                  {propState && (propState.houses > 0 || propState.hotel) && (
                    <div className="tile-bina-container">
                      {propState.hotel ? (
                        <div className="tile-hotel-piece animate-pop-in" style={{ display: 'flex', alignItems: 'center', gap: '2px' }} title={propState.houses > 0 ? `Ağa Yalısı + ${propState.houses} Ekstra Tezgâh (${5 + propState.houses}. Kat)` : "Ağa Yalısı"}>
                          <svg viewBox="0 0 28 28" width="20" height="20" style={{ filter: 'drop-shadow(0 3px 6px rgba(0,0,0,0.85))' }}>
                            <path d="M2 13 L14 3 L26 13 L26 26 C26 26.6 25.4 27 24.8 27 L3.2 27 C2.6 27 2 26.6 2 26 Z" fill="url(#hotelRedGrad)" stroke="#4c0519" strokeWidth="2" />
                            <path d="M2 13 L14 3 L26 13" fill="none" stroke="#ffe4e6" strokeWidth="2.2" strokeLinecap="round" />
                            <rect x="6" y="15" width="4" height="4" rx="0.5" fill="#fef08a" />
                            <rect x="18" y="15" width="4" height="4" rx="0.5" fill="#fef08a" />
                            <rect x="11" y="18" width="6" height="9" fill="#fbbf24" stroke="#4c0519" strokeWidth="1" />
                            <defs>
                              <linearGradient id="hotelRedGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#f43f5e" />
                                <stop offset="100%" stopColor="#be123c" />
                              </linearGradient>
                            </defs>
                          </svg>
                          {propState.houses > 0 && (
                            <span style={{ fontSize: '0.65rem', fontWeight: 900, color: '#fbbf24', background: '#0f172a', borderRadius: '4px', padding: '0 3px', border: '1px solid #fbbf24', lineHeight: 1 }}>
                              +{propState.houses}
                            </span>
                          )}
                        </div>
                      ) : (
                        <div className="tile-houses-row">
                          {Array.from({ length: Math.min(propState.houses, 4) }).map((_, idx) => (
                            <div key={idx} className="tile-house-piece animate-pop-in" title={`${propState.houses} Tezgâh`}>
                              <svg viewBox="0 0 24 24" width="16" height="16" style={{ filter: 'drop-shadow(0 2.5px 5px rgba(0,0,0,0.85))' }}>
                                <path d="M3 10 L12 3 L21 10 L21 21 C21 21.6 20.6 22 20 22 L4 22 C3.4 22 3 21.6 3 21 Z" fill="url(#houseGreenGrad)" stroke="#022c22" strokeWidth="2" />
                                <path d="M3 10 L12 3 L21 10" fill="none" stroke="#a7f3d0" strokeWidth="2.2" strokeLinecap="round" />
                                <rect x="9" y="14" width="6" height="8" rx="0.5" fill="#fef08a" stroke="#022c22" strokeWidth="1" />
                                <defs>
                                  <linearGradient id="houseGreenGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#34d399" />
                                    <stop offset="100%" stopColor="#059669" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            </div>
                          ))}
                          {propState.houses > 4 && (
                            <span style={{ fontSize: '0.65rem', fontWeight: 900, color: '#fbbf24', background: '#0f172a', borderRadius: '4px', padding: '0 2px' }}>+{propState.houses - 4}</span>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                propState && propState.houses > 0 && (
                  <div className="tile-bina-container special-tile-bina" style={{ position: 'absolute', top: '2px', left: '50%', transform: 'translateX(-50%)', zIndex: 12, display: 'flex', alignItems: 'center', gap: '2px', background: 'rgba(15,23,42,0.88)', padding: '2px 5px', borderRadius: '6px', border: '1.5px solid #22c55e', boxShadow: '0 2px 8px rgba(0,0,0,0.6)' }}>
                    <div className="tile-houses-row" style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                      {Array.from({ length: Math.min(propState.houses, 3) }).map((_, idx) => (
                        <div key={idx} className="tile-house-piece animate-pop-in" title={`${propState.houses} Tezgâh (${Math.pow(2, propState.houses)}x Kira)`}>
                          <svg viewBox="0 0 24 24" width="13" height="13" style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.85))' }}>
                            <path d="M3 10 L12 3 L21 10 L21 21 C21 21.6 20.6 22 20 22 L4 22 C3.4 22 3 21.6 3 21 Z" fill="url(#houseGreenGrad)" stroke="#022c22" strokeWidth="2" />
                            <path d="M3 10 L12 3 L21 10" fill="none" stroke="#a7f3d0" strokeWidth="2.2" strokeLinecap="round" />
                          </svg>
                        </div>
                      ))}
                      {propState.houses > 3 && (
                        <span style={{ fontSize: '0.6rem', fontWeight: 900, color: '#fbbf24' }}>+{propState.houses - 3}</span>
                      )}
                    </div>
                    <span style={{ fontSize: '0.68rem', fontWeight: 900, color: '#4ade80', marginLeft: '3px', whiteSpace: 'nowrap' }}>
                      {Math.pow(2, propState.houses)}x
                    </span>
                  </div>
                )
              )}
              
              <div className="space-content">
                {space.type !== 'property' && <SpaceIcon type={space.type} name={space.name} />}
                <span className="space-name">{getDisplayName(space.name)}</span>
                {space.price && <span className="space-price">₺{space.price}</span>}
                {!space.price && space.type === 'tax' && <span className="space-price">Vergi</span>}
                {space.type === 'parking' && gameData?.freeParkingPool > 0 && (
                  <span className="space-price" style={{ color: '#fbbf24', fontWeight: 800 }}>₺{gameData.freeParkingPool}</span>
                )}
              </div>

              {propState?.mortgaged && (
                <div className="mortgage-overlay animate-pop-in">
                  <span className="mortgage-lock-text">🔒 İPOTEKLİ</span>
                </div>
              )}

              {/* Prominent Ownership Badge & Initial Tag (Positioned opposite to color-bar to prevent overlap) */}
              {propState?.ownerPlayerId && (() => {
                const ownerPlayer = players?.find(p => p.playerId === propState.ownerPlayerId);
                const ownerColor = ownerPlayer?.color || '#fbbf24';
                const spaceId = space.id;
                let edgeStyle = {};

                if (spaceId >= 0 && spaceId <= 10) {
                  edgeStyle = { bottom: '4px', right: '4px' };
                } else if (spaceId > 10 && spaceId <= 20) {
                  edgeStyle = { bottom: '4px', left: '4px' };
                } else if (spaceId > 20 && spaceId <= 30) {
                  edgeStyle = { top: '4px', right: '4px' };
                } else if (spaceId > 30 && spaceId <= 39) {
                  edgeStyle = { bottom: '4px', right: '4px' };
                }

                // Initial text generation: e.g. "Boyozcu Bülent" -> "BB", "Bugra" -> "BU"
                let initialText = 'AĞA';
                if (ownerPlayer?.name) {
                  const parts = ownerPlayer.name.trim().split(/\s+/);
                  if (parts.length > 1) {
                    initialText = (parts[0][0] + parts[1][0]).toUpperCase();
                  } else {
                    initialText = parts[0].substring(0, 2).toUpperCase();
                  }
                }

                return (
                  <div 
                    className="owner-tile-badge animate-pop-in" 
                    style={{ 
                      backgroundColor: ownerColor,
                      boxShadow: `0 0 8px ${ownerColor}90`,
                      ...edgeStyle
                    }}
                    title={`Sahibi: ${ownerPlayer?.name || 'Ağa'}`}
                  >
                    <span className="owner-initial">{initialText}</span>
                  </div>
                );
              })()}

              {/* Multi-player spaced out token container along inner border track */}
              <div className="players-container">
                {playersHere.map((p, i) => {
                  const styleOffset = getTokenPositionStyle(i, playersHere.length, space.id);
                  return (
                    <div 
                      key={p.playerId || p.id || i} 
                      className={`player-token-anim ${activeHonks?.[p.playerId] ? 'honking' : ''}`}
                      style={{ 
                        ...styleOffset
                      }}
                      title={p.name}
                    >
                      {activeHonks?.[p.playerId] && (
                        <div className="honk-bubble-popup">HONKKK!</div>
                      )}
                      <TokenIcon token={p.token} color={p.color} size="var(--board-token-size)" />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Board;
